"use client";

import { SectionHeading } from "@repo/components";
import { ADDRESS_FORM_FIELDS } from "@repo/constants/checkout";
import { COUNTRY_CODE_PHONE_PREFIX } from "@repo/constants/common";
import { normalizeSaudiPhone, validation } from "@repo/lib/utils";
import { Button, ErrorMessage, Input, SelectCity } from "@repo/ui";
import { useTranslations } from "next-intl";
const CheckoutGuestShipping = ({
  formValues,
  formErrors,
  setFormErrors,
  handleValidation,
  handleAddressComplete,
  setSelectedAddress
}) => {
  const t = useTranslations("Common");
  const tAccount = useTranslations("Account");
  const handleSubmit = e => {
    e.preventDefault();
    const errors = validation(formValues, t);
    if (!Object.keys(errors).length) {
      const {
        street,
        city,
        state,
        zipCode,
        firstName,
        lastName,
        phoneNumber,
        email,
        line1,
        country
      } = formValues;

      // Normalize phone number
      const normalizedPhone = normalizeSaudiPhone(phoneNumber);
      setSelectedAddress({
        street,
        city,
        state,
        zipCode,
        firstName,
        lastName,
        phoneNumber: normalizedPhone,
        email,
        line1,
        country
      });
      handleAddressComplete();
    } else {
      setFormErrors(errors);
      console.log("Failed to submit the form, please check the form fields");
    }
  };
  return <form onSubmit={handleSubmit} data-sentry-component="CheckoutGuestShipping" data-sentry-source-file="CheckoutGuestShipping.jsx">
      <SectionHeading title={tAccount("Add_Address")} data-sentry-element="SectionHeading" data-sentry-source-file="CheckoutGuestShipping.jsx" />
      <div className="border-supportiveDarkGray mt-3 md:border md:py-4">
        <div className="flex flex-wrap md:p-4">
          {ADDRESS_FORM_FIELDS?.map(({
          id,
          type,
          name,
          placeholder,
          label,
          readOnly,
          disabled
        }) => <div key={id} className="mb-6 w-full md:w-1/2 md:odd:pe-4">
                {type === "select" ? <SelectCity label={t("City")} defaultValue={t("Select_City")} name={name} value={formValues?.[name]} disabled={disabled} onChange={handleValidation} /> : name === "phoneNumber" ? <div>
                    <label className="mb-2 block text-sm font-medium text-[#5E5E5E]">
                      {t(label)}
                    </label>
                    <div className="relative">
                      {<span className="text-supportiveBlack absolute mt-0.5 inline-flex h-8 items-center bg-gray-100 px-2 text-base font-medium md:h-10 ltr:ml-0.5 rtl:mr-0.5" dir="ltr">
                          {COUNTRY_CODE_PHONE_PREFIX}
                        </span>}
                      <Input type="tel" name="phoneNumber" placeholder={t(placeholder)} value={`${formValues?.phoneNumber}`} onChange={handleValidation} className="ltr:pl-16 rtl:pr-14 rtl:text-right" />
                    </div>
                  </div> : <Input type="text" name={name} placeholder={t(placeholder)} value={formValues?.[name]} onChange={handleValidation} readOnly={readOnly} disabled={disabled} label={t(label)} />}
                <ErrorMessage message={formErrors?.[name]} />
              </div>)}
        </div>
        <div className="text-end md:px-4">
          <Button type="submit" variant="primary" size="md" data-sentry-element="Button" data-sentry-source-file="CheckoutGuestShipping.jsx">
            <span className="flex items-center justify-center">
              {t("Continue")}
            </span>
          </Button>
        </div>
      </div>
    </form>;
};
export default CheckoutGuestShipping;